export default {
  setLeads({ commit }, payload) {
    commit('setLeads', payload)
  },

  setAtrasadas({ commit }, payload) {
    commit('setAtrasadas', payload)
  },

  setVenceAmanha({ commit }, payload) {
    commit('setVenceAmanha', payload)
  },

  setVenceHoje({ commit }, payload) {
    commit('setVenceHoje', payload)
  }
}
